<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Facturas de Compra <a routerLink="/purchases/invoice" class="clickeable"
				style="text-decoration: none;">
				<span class="sp-con-default">
					<i class="fa-solid fa-circle-plus"></i>
					<i style="color: var(--bs-bg-servicios);" class="fa-solid fa-tag sp-el-default"></i>
				</span>
				<span>
					Nueva Factura
				</span>
			</a>
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row" id="options-date">
					<div class="col-sm form-group">
						<label for="type" class="form-label">Ver resultados de </label>
						<select name="type" id="type" (change)="changeType()" [(ngModel)]="type" class="form-select">
							<option value="0">Hoy</option>
							<option value="1">Últimos 7 días</option>
							<option value="2">Este mes</option>
							<option value="3">El mes pasado</option>
							<option value="4">Últimos dos meses</option>
							<option value="5">Últimos tres meses</option>
							<option value="6">Intervalo de fecha</option>
						</select>
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="startDate" class="form-label">Fecha Inicio</label>
						<input type="date" id="startDate" [(ngModel)]="startDate"
							name="startDate" class="form-control">
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="endDate" class="form-label">Ver resultados de </label>
						<input type="date" id="endDate" max="{{todayDate | date:'yyyy-MM-dd'}}"
							[(ngModel)]="endDate" name="endDate" class="form-control">
					</div>
					<div class="col-auto form-group" *ngIf="type==6">
						<div class="h-100 row align-items-end">
							<button class="btn btn-success" (click)="changeDate()" [disabled]="loadingData">
							<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingData"></span>
							<i class="fa fa-filter" *ngIf="!loadingData"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm">
						<span class="form-label">Tipo de documento</span>
						<div class="row" style="padding: 1em;">
							<div class="col form-check">
								<input class="form-check-input" (change)="filterCheck()" [(ngModel)]="invoiceCheck"
									type="checkbox" value="" id="invoiceCheck">
								<label class="form-check-label" for="invoiceCheck">
									Factura
								</label>
							</div>
							<div class="col form-check">
								<input class="form-check-input" (change)="filterCheck()" [(ngModel)]="receiptCheck"
									type="checkbox" value="" id="receiptCheck">
								<label class="form-check-label" for="receiptCheck">
									Recibo
								</label>
							</div>
						</div>
					</div>
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Buscar por número o serie</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="searchVendor"
								placeholder="Ingresa número o serie" name="filterVendors" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
					<div class="col-sm form-group">
						<label for="filterWarehouse" class="form-label">Bodega</label>
						<select name="filterWarehouse" (change)="filterCheck()" [(ngModel)]="warehouse"
							id="filterWarehouse" class="form-select">
							<option [ngValue]="null">Todas</option>
							<option *ngFor="let warehouse of warehouseList" [ngValue]="warehouse.id">
								{{warehouse.name}}
							</option>
						</select>
					</div>
					<div class="col-sm form-group">
						<label for="order" class="form-label">Orden </label>
						<select name="order" id="order" (change)="changeOrder()" [(ngModel)]="isAscendent"
							class="form-select">
							<option value="1">Ascendente</option>
							<option value="0">Descendente</option>
						</select>
						<span class="form-text">
							<i class="fa fa-circle-info"></i>
							<ng-container *ngIf="isAscendent==1">
								Los resultados se muestran de la fecha más lejana a la más reciente
							</ng-container>
							<ng-container *ngIf="isAscendent==0">
								Los resultados se muestran de la fecha más reciente a la más lejana
							</ng-container>
						</span>
					</div>
				</div>
				<div class="table-responsive" [class.table-responsive-without]="waitingFor" style="margin-bottom: 0;">
					<table class="table table-striped" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="ta th-balance" [class.balance-success]="total>=0" colspan="9">
									Total 
									<span *ngIf="!loadingData">{{total | currency:'Q'}}</span>
									<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingData"></span>
								</th>
							</tr>
							<tr>
								<th class="ta">
									Serie
								</th>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Fecha Crea
								</th>
								<th class="ta">
									Fecha Cert
								</th>
								<th class="ta">
									Bodega
								</th>
								<th class="ta">
									NIT
								</th>
								<th class="ta">
									Cliente
								</th>
								<th class="ta">
									Total
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="!loadingData">
<ng-container *ngFor="let invoice of pagination.filter">
								<tr [class.canceled-invoice]="invoice.cancelled"
									[class.hide-all]="waitingFor?.id==invoice.id">
									<td class="ta">
										{{invoice.series}}
									</td>
									<td class="ta">
										{{invoice.number}}
									</td>
									<td class="ta">
										{{convertToString(invoice.date)}}
									</td>
									<td class="ta">
										{{convertToString(invoice.accountingDate)}}
									</td>
									<td class="ta">
										{{getWarehouseName(invoice.warehouse)}}
									</td>
									<td class="ta">
										<div *ngIf="invoice.providerData">
											{{invoice.providerData.nit}}
										</div>
									</td>
									<td class="ta limit-td">
										<div *ngIf="invoice.providerData">
											{{invoice.providerData.name}}
										</div>
									</td>
									<td class="ta">
										{{(invoice.totalCost + invoice.totalTaxes + invoice.extraTax) | currency :"Q"}}
										<!-- {{(invoice.totalCost + invoice.totalTaxes + invoice.extraTax) | currency :
										((invoice.currency==1)?"$":"Q")}} -->
										<!-- {{(invoice.balance) | currency :
										((invoice.currency==1)?"$":"Q")}} -->
									</td>
									<td class="ta">
										<div style="display: flex; justify-content: space-between;" >
											<span class="clickeable text-info" title="Editar"
												(click)="editInvoice(invoice)" [appCheckPermission]="[5023]"
												[permissionType]="permissionType.UPDATE" *ngIf="!invoice.isNcre">
												<i class="fa fa-edit"></i>
											</span>
											<span class="clickeable text-info" title="Trasladar"
												(click)="movingToWarehouse(invoice)" [appCheckPermission]="[5023]"
												[permissionType]="permissionType.UPDATE" *ngIf="!invoice.isNcre">
												<i *ngIf="!moving[invoice.id]" class="fa-solid fa-truck-ramp-box"></i>
												<span *ngIf="moving[invoice.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
											<div class="container-superposition" title="Borrar"
												[appCheckPermission]="[5023]" [permissionType]="permissionType.DELETE">
												<div class="element-superposition" *ngIf="waitingFor?.id == invoice.id">
													<span>¿Está seguro que desea eliminar esta factura?</span>
													<span class="a-container">
														<span class="a-hover" (click)="resetDeletingDiv()"><i
																class="fa fa-ban"></i>NO</span>
														<span class="a-hover text-danger"><i class="fa fa-trash"
																(click)="confirmDelete(invoice)"></i>SÍ</span>
													</span>
												</div>
												<span class="clickeable text-danger" (click)="deleteInvoice(invoice)">
													<i *ngIf="!deleting[invoice.id]" class="fa fa-trash"></i>
													<span *ngIf="deleting[invoice.id]"
														class="spinner-border spinner-border-sm"
														aria-hidden="true"></span>
												</span>
											</div>
											<span (click)="detailingInvoice(invoice)" title="Ver detalle"
												class="clickeable"
												[ngClass]="invoice['allAssociated']?'text-success':'text-warning'"
												[appCheckPermission]="[5023]" [permissionType]="permissionType.READ" *ngIf="!invoice.isNcre">
												<i *ngIf="!detailing[invoice.id]" class="fa fa-eye"></i>
												<span *ngIf="detailing[invoice.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
											<!-- <span class="clickeable text-info" title="Generar Documento Fiscal"
												(click)="generateFiscalDocument(invoice)" [appCheckPermission]="[5023]"
												[permissionType]="permissionType.UPDATE" *ngIf="!invoice.isNcre">
												<i class="fa fa-file-invoice"></i>
											</span> -->
										</div>
									</td>
								</tr>
							</ng-container>
							</ng-container>
							<tr class="tr-middle" *ngIf="loadingData">
								<td colspan="10">
								<app-loading-animation [height]="'5rem'"></app-loading-animation>
								<p class="display-6">Cargando...</p>
								</td>
							</tr>
							<tr *ngIf="pagination.filter.length == 0 && !loadingData">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron documentos en las fechas
									seleccionadas
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
	<app-modal-invoice-sale [isClient]="false" *ngIf="editing" [newSale]="newPurchase" [isCreating]="false"
		(close)="editing = false; newPurchase = null"></app-modal-invoice-sale>
	<div class="hide-background" *ngIf="waitingFor || invoiceDetail">
		<div class="for-click" (click)="resetDeletingDiv()"></div>
		<div class="modal" tabindex="-1" *ngIf="invoiceDetail" style="justify-content: flex-start !important;">
			<div class="modal-dialog" style=" margin-bottom: 3.5em !important;">
				<div class="modal-content">
					<div class="modal-header">
						<h1>{{(isMoving)?'Traslado de Factura de Compra':'Detalles de Factura de Compra'}}</h1>
						<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark"
								(click)="resetModalDetailAndMove()"></i></h1>
					</div>
					<div class="modal-body">
						<ng-container *ngIf="isMoving">
							<div class="row">
								<div class="col form-group">
									<label for="from" class="form-label">Desde</label>
									<input type="text" id="from" name="from" class="form-control"
										[value]="getWarehouseName(invoiceDetail.warehouse)" disabled>
								</div>
								<div class="col form-group">
									<label for="from" class="form-label">Hacia</label>
									<div class="input-group">
										<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.warehouse"
											[placeholder]="'Ingresa o crea una bodega'"
											[filterElements]="filterWarehouses" [typeElements]="'warehouse'"
											(changeMethod)="verifiedInput($event.event)"
											(inputMethod)="handleInput($event.event)"
											(getTitle)="$event.filterElement.title = $event.filterElement.name"
											(changeStatus)="changeStatusInput($event.filterElement)"></app-input-autocomplete>
									</div>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="!isMoving">
							<p class="p-invoice" style="text-align: right;">Serie <b>{{invoiceDetail.series}}</b></p>
							<p class="p-invoice" style="text-align: right;">Número <b>{{invoiceDetail.number}}</b></p>
						</ng-container>
						<div class="">
							<table class="table table-striped">
								<thead>
									<tr>
										<!-- Cantidad	Producto	Descripcion	Precio	Total -->
										<th class="td-center"
											[rowSpan]="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'?'2':'1'">
											Cantidad
										</th>
										<th class="td-center" rowspan="1"
											[colSpan]="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'?'2':'1'">
											Producto
										</th>
										<th class="td-center"
											[rowSpan]="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'?'2':'1'">
											Precio
										</th>
										<th class="td-center"
											[rowSpan]="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'?'2':'1'">
											Total
										</th>
									</tr>
									<tr *ngIf="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'">
										<th
											[colSpan]="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'?'1':'2'">
											Nombre</th>
										<th class="td-center"
											*ngIf="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'">
											¿Debe ser asociado?</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let product of invoiceDetail['detail']">
										<td class="td-center">{{product.quantity}}</td>
										<td>
											<ng-container *ngIf="isMoving">{{product.productData.name}}</ng-container>
											<ng-container *ngIf="!isMoving">
												<span *ngIf="productToTransform?.id != product.id" [ngClass]="product.productData.idAssociated
														|| (warehousesById[invoiceDetail.warehouse] != 'bodega por defecto' 
														&& !product.productData.code.includes('XML')) 
														|| !product.productData.notAssociated ? 'text-success':'text-warning'">

													<i *ngIf="product.productData.notAssociated" [tooltip]="product.productData.idAssociated 
														|| (warehousesById[invoiceDetail.warehouse] != 'bodega por defecto' 
														&& !product.productData.code.includes('XML')) 
														|| !product.productData.notAssociated ? 'Producto asociado':'Producto no asociado'" [ngClass]="product.productData.idAssociated 
														|| (warehousesById[invoiceDetail.warehouse] != 'bodega por defecto' 
														&& !product.productData.code.includes('XML')) 
														|| !product.productData.notAssociated ? 'text-success fa fa-circle-check':'text-warning fa fa-warning'">

													</i>
													{{product.productData.idAssociated ?
													productsIds[product.productData.idAssociated]?.name :
													product.productData.name}}
													<i (click)="addToQueueTransform(product)" *ngIf="!gettingProducts[product.productData.id] && !product.productData.idAssociated 
														&& warehousesById[invoiceDetail.warehouse] != 'bodega por defecto' && product.productData.code.includes('XML')
														&& product.productData.notAssociated" class="clickeable text-info fa-solid fa-arrows-rotate"></i>
													<i *ngIf="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto' && product.productData.code.includes('XML')"
														(click)="showModalSeries(invoiceDetail, product.productData.id)"
														class="clickeable text-info fa fa-list"></i>
													<span *ngIf="gettingProducts[product.productData.id]"
														class="spinner-border spinner-border-sm"
														aria-hidden="true"></span>
												</span>
												<span *ngIf="productToTransform?.id == product.id">
													<div class="form-group">
														<label for="product" class="form-text"><b
																style="font-size: 1.1rem;">{{product.productData.idAssociated?
																productsIds[product.productData.idAssociated].name :
																product.productData.name}}</b>
															transformar a</label>
														<div class="input-group input-group-sm">
															<button class="btn btn-danger" (click)="resetTransform()"><i
																	class="fa fa-xmark"></i></button>
															<button class="btn btn-success"
																(click)="transform(product.quantity)"
																[disabled]="!inputs.product.verified">
																<i *ngIf="!transforming" class="fa-solid fa-save"></i>
																<span *ngIf="transforming"
																	class="spinner-border spinner-border-sm"
																	aria-hidden="true"></span>
															</button>
															<app-input-autocomplete [inputs]="inputs.product"
																(inputMethod)="writeProduct($event.event)"
																[placeholder]="'Ingresa un producto'"
																(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - '+$event.filterElement.name"
																[filterElements]="filterProducts"
																(changeStatus)="selectProduct($event.filterElement)"
																[allBorderRadius]="false"></app-input-autocomplete>
														</div>
													</div>
												</span>
											</ng-container>
										</td>
										<td class="td-center"
											*ngIf="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'">
											<span (click)="changeAssociated(product)" class="associated">
												<i
													[ngClass]="product.productData.notAssociated?'fa-solid fa-circle-check text-success':'fa-regular fa-circle text-secondary'"></i>
												<span
													[ngClass]="product.productData.notAssociated?'text-success':'text-secondary'">
													{{product.productData.notAssociated?'SÍ':'NO'}}
												</span>
											</span>
										</td>
										<!-- <td class="td-center">{{product.price+product.taxes | currency : (invoiceDetail.currency==1?'$':'Q')}}</td> -->
										<td class="td-center">{{product.price+product.taxes | currency : 'Q'}}</td>
										<!-- <td class="td-center">{{product.quantity * (product.price+product.taxes) | currency : (invoiceDetail.currency==1?'$':'Q')}}</td> -->
										 <td class="td-center">{{product.quantity * (product.price+product.taxes) | currency : 'Q'}}</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>
										<td [colSpan]="warehousesById[invoiceDetail.warehouse] != 'bodega por defecto'?'4':'3'"
											class="td-center">Total</td>
										<td class="td-center">
											<!-- {{invoiceDetail.totalCost + invoiceDetail.totalTaxes + invoiceDetail.extraTax | currency : (invoiceDetail.currency==1?'$':'Q')}} -->
											 {{invoiceDetail.totalCost + invoiceDetail.totalTaxes + invoiceDetail.extraTax | currency : 'Q'}}
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-success" *ngIf="isMoving"
							[disabled]="!inputs.warehouse.verified || moving[invoiceDetail.id]"
							(click)="confirmMovingToWarehouse()">
							<i *ngIf="!moving[invoiceDetail.id]" class="fa-solid fa-truck-ramp-box"></i>
							<span *ngIf="moving[invoiceDetail.id]" class="spinner-border spinner-border-sm"
								aria-hidden="true"></span>TRASLADAR</button>
					</div>
				</div>
			</div>
		</div>
		<app-modal-purchase-serie *ngIf="isModalSeriesShowed" [newListSeries]="newPurchaseSerie"
			(close)="closeModalSeries($event)"></app-modal-purchase-serie>
	</div>
	<div class="hide-background" *ngIf="showCaisModal">
		<div class="for-click" (click)="closeCaisModal()"></div>

		<div class="modal" tabindex="-1" style="justify-content: flex-start !important;">
			<div class="modal-dialog" style=" margin-bottom: 3.5em !important;">
			<div class="modal-content">

				<!-- HEADER -->
				<div class="modal-header">
				<h1>Documento Fiscal (CAIS)</h1>
				<h1 style="left: 0;" class="i-hover">
					<i class="fa fa-xmark" (click)="closeCaisModal()"></i>
				</h1>
				</div>

				<!-- BODY -->
				<div class="modal-body" *ngIf="caisDetail">

				<p class="p-invoice text-end">
					Serie: <b>{{caisDetail.series}}</b>
				</p>

				<p class="p-invoice text-end">
					Número: <b>{{caisDetail.number}}</b>
				</p>

				<p class="p-invoice">
					Serie origen: <b>{{caisDetail.originSeries}}</b>
				</p>

				<p class="p-invoice">
					Número origen: <b>{{caisDetail.originNumber}}</b>
				</p>

				<p class="p-invoice">
					Fecha emisión: <b>{{convertToString(caisDetail.issueDate)}}</b>
				</p>

				<table class="table table-striped mt-3">
					<thead>
					<tr>
						<th class="td-center">Producto</th>
						<th class="td-center">Cantidad</th>
						<th class="td-center">Precio</th>
						<th class="td-center">Total</th>
					</tr>
					</thead>

					<tbody>
					<tr *ngFor="let d of caisDetail.details">
						<td class="td-center">
						{{ d.descriptionProduct }}
						</td>
						<td class="td-center">
						{{ d.quantity | number:'1.2-2' }}
						</td>
						<td class="td-center">
						<!-- {{ d.price | currency : (d.currency==1?'$':'Q') }} -->
						{{ d.price | currency : 'Q' }}
						</td>
						<td class="td-center">
						<!-- {{ (d.quantity * d.price) | currency : (d.currency==1?'$':'Q') }} -->
						  {{ (d.quantity * d.price) | currency : 'Q' }}
						</td>
					</tr>
					</tbody>

					<tfoot>
					<tr>
						<th colspan="3" class="td-center">Total documento</th>
						<th class="td-center">
						<!-- {{ caisDetail.total | currency : (caisDetail.currency==1?'$':'Q') }} -->
						{{ caisDetail.total | currency : 'Q' }}
						</th>
					</tr>
					</tfoot>

				</table>

				</div>

				<!-- FOOTER -->
				<div class="modal-footer">
				<button class="btn btn-secondary" (click)="closeCaisModal()">
					Cerrar
				</button>
				</div>

			</div>
			</div>
		</div>
	</div>
</div>